import { formatDate } from '@/web-task/filter.js'
import { soFarDate } from '@/web-task/utils.js'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const landlordSurvey = (injured && injured.homeLandLordSurvey) || {}

	let arr = [
		{
			label: '被询问人姓名',
			value: landlordSurvey.intervieweeName,
		},
		{
			label: '被询问人电话',
			value: landlordSurvey.intervieweePhone,
		},
		{
			label: '被询问人身份',
			value: setting.landlordTypeMap[landlordSurvey.intervieweeIdentity],
		},
		{
			label: '伤者居住信息是否属实',
			value: setting.yesNoMap[landlordSurvey.facticity],
		},
	]

	if (landlordSurvey && landlordSurvey.facticity !== '0') {
		arr.push(
			{
				label: '实际居住地区',
				value: landlordSurvey.areaDesc,
			},
			{
				label: '详细地址',
				value: landlordSurvey.address,
			},
			{
				label: '伤者住房类型',
				value: setting.houseTypeMap[landlordSurvey.houseType],
			}
		)
		// 住房类型为租房时展示
		if (landlordSurvey.houseType === '2') {
			arr.push({
				label: '租房合同房东姓名',
				value: landlordSurvey.rentName,
			})
		}
		arr.push(
			{
				label: '居住开始时间',
				value: formatDate(landlordSurvey.beginTime),
			},
			{
				label: '居住结束时间',
				value: soFarDate(landlordSurvey.endTime),
			},
			{
				label: '是否常住',
				value: setting.yesNoMap[landlordSurvey.regular],
			},
			{
				label: '是否有同住人',
				value: setting.yesNoMap[landlordSurvey.hasTogether],
			}
		)

		if (landlordSurvey.togethers && landlordSurvey.togethers.length > 0) {
			if (landlordSurvey.togethers.length > 1) {
				landlordSurvey.togethers.forEach((item, key) => {
					arr.push(
						{
							label: `同住人姓名${key + 1}`,
							value: item.name,
						},
						{
							label: `同住人电话${key + 1}`,
							value: item.phone,
						},
						{
							label: `同住人与伤者关系`,
							value: item.relation,
						}
					)
				})
			} else {
				let together = landlordSurvey.togethers[0]
				arr.push(
					{
						label: `同住人姓名`,
						value: together && together.name,
					},
					{
						label: `同住人电话`,
						value: together && together.phone,
					},
					{
						label: `同住人与伤者关系`,
						value: together && together.relation,
					}
				)
			}
		}
	}

	arr.push(
		{
			label: '是否签字',
			value: setting.yesNoMap[landlordSurvey.sign],
		},
		{
			label:
				landlordSurvey && landlordSurvey.facticity !== '0'
					? '备注（非必填）'
					: '备注（必填）',
			value: landlordSurvey.remark,
		}
	)

	return {
		title: '房东/物业询问笔录',
		children: arr,
	}
}
